import React from 'react';

export const Github = () => {
  return (
    <div className='container mt-5'>
      <h2 className="text-center">Our Github</h2>
    </div>
  );
};

export default Github;



// WEBPACK FOOTER //
// ./src/components/Pages/Github.js